require('../libs/trunk8');

import Device from '../helpers/Device';

export default class TextTruncate {
  constructor() {
    this.news = {
      $title: $('.sec-news .news .content .title p'),
      $body: $('.sec-news .news .content .body p')
    };

    this._exec();
  }

  /**
   * 各箇所の文言切り詰めを実行.
   * @private
   */
  _exec() {
    this._truncateNews();
  }

  /**
   * Newsの文言を切り詰める.
   * @private
   */
  _truncateNews() {
    if (Device.isPc()) {
      this.news.$title.trunk8({
        lines: 3
      });

      this.news.$body.trunk8({
        lines: 4
      });
    } else {
      this.news.$title.trunk8({
        lines: 2
      });

      this.news.$body.trunk8({
        lines: 3
      });
    }
  }
}
